export enum MapProviders {
  TOMTOM = 'tomtom',
  GOOGLE = 'google',
}
